import { render, staticRenderFns } from "./StartWelcomeItem.vue?vue&type=template&id=0a9c8903&scoped=true&"
import script from "./StartWelcomeItem.vue?vue&type=script&lang=ts&"
export * from "./StartWelcomeItem.vue?vue&type=script&lang=ts&"
import style0 from "./StartWelcomeItem.vue?vue&type=style&index=0&id=0a9c8903&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9c8903",
  null
  
)

export default component.exports